// extracted by mini-css-extract-plugin
module.exports = {"footerActions":"styles_footerActions__3g2i9","footerDisclaimer":"styles_footerDisclaimer__mOrBa","footer":"styles_footer__MHfbK"};